import React from "react";

export function OptionCard({ label, selected, onClick, multi, disabled, testid }) {
  return (
    <button
      type="button"
      className={`cw-option ${selected ? "selected" : ""}`}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      data-testid={testid}
    >
      <span className={`cw-option-check ${multi ? "square" : ""}`}>
        {selected ? (
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
            <path d="M2 6.5L4.8 9L10 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        ) : null}
      </span>
      <span>{label}</span>
    </button>
  );
}

export function ProgressBar({ current, total, testid = "progress" }) {
  const pct = Math.max(0, Math.min(100, (current / total) * 100));
  return (
    <div className="cw-progress-inner" data-testid={testid}>
      <div className="cw-progress-track" style={{ flex: 1 }} aria-hidden>
        <div className="cw-progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="cw-label cw-tabular" data-testid="progress-label" style={{ whiteSpace: "nowrap" }}>
        <span style={{ color: "var(--cw-linen)" }}>{String(current).padStart(2, "0")}</span>
        <span style={{ margin: "0 6px", opacity: 0.5 }}>/</span>
        <span>{String(total).padStart(2, "0")}</span>
      </div>
    </div>
  );
}

export function Banner({ children, kind = "info", testid = "banner" }) {
  return (
    <div className={`cw-banner ${kind}`} data-testid={testid}>
      {children}
    </div>
  );
}
